/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,

  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  esferaDesde: 0,
  esferaHasta: 0,
  cilindroDesde: 0,
  cilindroHasta: 0,
};

const nameItemText = "Rango";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// ########################################################################### 
//
const RangoDialog = ({
  open = false,
  onSaveRango,
  onCloseRangoDialog,
  itemCrud,
  actionCrud,
  rangosList,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      let _itemCrud = {
        id: itemCrud?.id,
        esferaDesde: itemCrud?.esfera_desde ?? 0,
        esferaHasta: itemCrud?.esfera_hasta ?? 0,
        cilindroDesde: itemCrud?.cilindro_desde ?? 0,
        cilindroHasta: itemCrud?.cilindro_hasta ?? 0,
      };
      setItemCrudLocal(_itemCrud);
    }
  }, [actionCrud, itemCrud]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    setItemCrudLocal(initialState);
    onCloseRangoDialog();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (isNaN(itemCrudLocal.esferaDesde)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un Número Válido para Esfera Desde",
        });
        setShowMessage(true);
        return;
      }
      if (isNaN(itemCrudLocal.esferaHasta)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un Número Válido para Esfera Hasta",
        });
        setShowMessage(true);
        return;
      }
      if (isNaN(itemCrudLocal.cilindroDesde)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un Número Válido para Cilindro Desde",
        });
        setShowMessage(true);
        return;
      }
      if (isNaN(itemCrudLocal.cilindroHasta)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un Número Válido para Cilindro Hasta",
        });
        setShowMessage(true);
        return;
      }

      // valido esfera desde
      if (itemCrudLocal.esferaDesde < -30 || itemCrudLocal.esferaDesde > 30 || (itemCrudLocal.esferaDesde * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor de la Esfera Desde no es válido",
        });
        setShowMessage(true);
        return;
      }
      // valido esfera hasta
      if (itemCrudLocal.esferaHasta < -30 || itemCrudLocal.esferaHasta > 30 || (itemCrudLocal.esferaHasta * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor de la Esfera Hasta no es válido",
        });
        setShowMessage(true);
        return;
      }
      // valido cilindro desde
      if (itemCrudLocal.cilindroDesde < -10 || itemCrudLocal.cilindroDesde > 10 || (itemCrudLocal.cilindroDesde * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor del Cilindro Desde no es válido",
        });
        setShowMessage(true);
        return;
      }
      // valido cilindro hasta
      if (itemCrudLocal.cilindroHasta < -10 || itemCrudLocal.cilindroHasta > 10 || (itemCrudLocal.cilindroHasta * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor del Cilindro Hasta no es válido",
        });
        setShowMessage(true);
        return;
      }
      // valido que no haya rangos superpuestos con otro ya registrado
      if (rangosList.some(
        rango => rango.esfera_desde <= itemCrudLocal.esferaHasta
          && rango.esfera_hasta >= itemCrudLocal.esferaDesde
          && rango.cilindro_desde <= itemCrudLocal.cilindroHasta
          && rango.cilindro_hasta >= itemCrudLocal.cilindroDesde
          && rango.id !== itemCrudLocal.id
      )) {
        setMessage({
          severity: "error",
          messageText: "El Rango se superpone con otro ya registrado",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      esferaDesde: parseInt(itemCrudLocal.esferaDesde),
      esferaHasta: parseInt(itemCrudLocal.esferaHasta),
      cilindroDesde: parseInt(itemCrudLocal.cilindroDesde),
      cilindroHasta: parseInt(itemCrudLocal.cilindroHasta),
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    onSaveRango(_itemCrud, actionCrud);
    setIsDoingSomething(false);

    setMessage({
      messageText: "Rango guardado correctamente",
      severity: "success",
    });
    setShowMessage(true);
    // limpiar los campos
    setItemCrudLocal(initialState);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleCloseDialog();
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "delete"
                ? "Quitar"
                : "Deshabilitar"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {/* >>>> Dialogo de Espera a que llegue respuesta */}
        <WaitingDialog open={isDoingSomething} />
        {/* >>>> Dialogo de Espera a que llegue respuesta */}

        <DialogContent dividers>
          <Box
            sx={{
              m: 1,
              p: 2,
              pt: 2,
              border: "1px solid LightGrey",
              borderRadius: "5px",
              backgroundColor: "primary",
            }}
            className="box-table"
          >
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={5} >
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  // Que solo se puedan ingresar numeros, negativos pero no el siguiente formato 0-0 o 0--0 o 0--0-0 o 0-0-0
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]{1,3}$|^-[0-9]{1,3}$|^0-0$|^0--0$|^0--0-0$|^0-0-0$',
                    maxLength: 3,
                    minLength: 1,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9-]/g, '');
                    }
                  }}
                  id="esferaDesde"
                  label="Esfera Desde (-30 a 30)"
                  variant="outlined"
                  size="small"
                  name="esferaDesde"
                  value={itemCrudLocal.esferaDesde ?? ""}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={5} >
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]{1,3}$|^-[0-9]{1,3}$|^0-0$|^0--0$|^0--0-0$|^0-0-0$',
                    maxLength: 3,
                    minLength: 1,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9-]/g, '');
                    }
                  }}
                  id="esferaHasta"
                  label="Esfera Hasta (-30 a 30)"
                  variant="outlined"
                  size="small"
                  name="esferaHasta"
                  value={itemCrudLocal.esferaHasta ?? ""}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete"}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={5} >
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]{1,3}$|^-[0-9]{1,3}$|^0-0$|^0--0$|^0--0-0$|^0-0-0$',
                    maxLength: 3,
                    minLength: 1,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9-]/g, '');
                    }
                  }}
                  id="cilindroDesde"
                  label="Cilindro Desde (-10 a 10)"
                  variant="outlined"
                  size="small"
                  name="cilindroDesde"
                  value={itemCrudLocal.cilindroDesde ?? ""}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={5} >
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '^[0-9]{1,3}$|^-[0-9]{1,3}$|^0-0$|^0--0$|^0--0-0$|^0-0-0$',
                    maxLength: 3,
                    minLength: 1,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9-]/g, '');
                    }
                  }}
                  id="cilindroHasta"
                  label="Cilindro Hasta (-10 a 10)"
                  variant="outlined"
                  size="small"
                  name="cilindroHasta"
                  value={itemCrudLocal.cilindroHasta ?? ""}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete"}
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              m: 1,
              p: 2,
              pt: 2,
              border: "1px solid LightGrey",
              borderRadius: "5px",
              backgroundColor: "primary",
            }}
            className="box-table"
          >
            <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 0 }}>
              {actionCrud !== "view" && (
                <Button
                  sx={{ mr: 1, backgroundColor: "warning" }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "delete" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "delete"
                    ? "Quitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>
              )}
              {actionCrud !== "delete" && (
                <Button
                  sx={{ mr: 2 }}
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              )}
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default RangoDialog;
